import React from 'react';
import { FormattedMessage } from 'react-intl';
import { TranslationKeys } from 'app/translations';
import { Chip } from '@mui/material';

export const SettingsSummaryScalesCustomTag = () => {
  return <Chip label={<FormattedMessage id={TranslationKeys.global_custom} />} size="small" sx={{ ml: 1 }} />;
};
